import { render, staticRenderFns } from "./SubscriptionPayResultDialog.vue?vue&type=template&id=1b73a976"
import script from "./SubscriptionPayResultDialog.vue?vue&type=script&lang=js"
export * from "./SubscriptionPayResultDialog.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionPayResultDialog.vue?vue&type=style&index=0&id=1b73a976&prod&lang=less"


/* normalize component */
import normalizer from "!D:\\Code\\ui\\comic_ai\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports